export async function fileToDataUrl(file: File) {
  return await new Promise<string>((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = (e) => {
      if (!e.target) return reject(e)
      resolve(e.target.result as string)
    }
    fileReader.onerror = (e) => reject(e)
    fileReader.readAsDataURL(file)
  })
}

export async function dataUrlToFile(
  dataUrl: string,
  fileName: string,
  mimeType: string
) {
  const request = await fetch(dataUrl)
  const arrayBuffer = await request.arrayBuffer()
  const file = new File([arrayBuffer], fileName, { type: mimeType })
  return file
}
